export { default as TabHeaderPart } from './Part.tab';
export { default as TabHeaderContent } from './Content.tab';
export { default as TabHeaderFactors } from './Factors.tab';
export { default as TabHeaderCause } from './Cause.tab';
export { default as TabHeaderProcess } from './Process.tab';
export { default as TabHeaderType } from './Type.tab';
export { default as TabHeaderFloor } from './Floor.tab';
export { default as TabHeaderArea } from './Area.tab';
